import { Attributes, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";
import { TimeZoneFormat } from "@singularsystems/neo-core/dist/Misc";

@NeoModel
export default class StaticExportFileSpecConfigurationLookup extends ModelBase {

    public staticExportFileSpecId: number = 0;

    @Rules.Required()
    @Attributes.Date(TimeZoneFormat.None)
    public activeStartDate: Date | null = null;

    @Attributes.Date(TimeZoneFormat.None)
    public activeEndDate: Date | null = null;

    @Rules.Required()
    public exportName: string = "";

    public fileSpecPropertiesConcatenated: string = "";

    public columnCount: number = 0;
}